import React from 'react';
import { ArrowDownIcon, ArrowUpIcon, Trash2Icon } from 'lucide-react';
import type { BuilderController } from './useBuilder';
import { NODE_KINDS } from '../nodeKinds';
import { cn } from '../../../src/lib/utils';
const btn = 'flex min-h-[36px] items-center gap-1 rounded-lg border border-night-line px-2.5 text-[11px] font-medium text-night-muted transition-colors hover:text-night-text focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet disabled:opacity-40';
export function NodeInspector({
  builder
}: {
  builder: BuilderController;
}) {
  const node = builder.selectedNode;
  if (!node) {
    return <div data-id="element-231" data-mp="1fk26ztjp10ik">
        <p className="text-[12px] text-night-muted" data-id="element-232" data-mp="1fjizl6ro5uis">Select a step on the canvas to configure it.</p>
        <ol className="mt-3 space-y-1" data-id="element-233" data-mp="1am0nj7icuz6k">
          {builder.nodes.map((n, index) => <li key={n.id} data-id="element-234" data-mp="39ws0ia65g7pf" data-mpi={index}>
              <button type="button" onClick={() => builder.selectNode(n.id)} className="flex w-full items-center gap-2 rounded-lg px-2 py-1.5 text-left text-[12px] text-night-text hover:bg-night-raised focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet" data-id="element-235" data-mp="39uxqhqwf2004">
                <span className="w-5 font-mono text-[10px] text-night-faint" data-id="element-236" data-mp="33hp85kil27pa">{index + 1}</span>
                {n.label}
                <span className="ml-auto text-[10px] text-night-faint" data-id="element-237" data-mp="38gthqc9f67g5">{NODE_KINDS[n.kind].label}</span>
              </button>
            </li>)}
        </ol>
      </div>;
  }
  const kind = NODE_KINDS[node.kind];
  const Icon = kind.icon;
  const index = builder.nodes.findIndex(n => n.id === node.id);
  return <div data-id="element-238" data-mp="3mdp3946uxrd3">
      <div className="flex items-center gap-2.5" data-id="element-239" data-mp="3mdyt8rrwjyis">
        <span className={cn('flex h-8 w-8 items-center justify-center rounded-lg', kind.tone)} data-id="element-240" data-mp="3rdunw0epmdlo">
          <Icon className="h-4 w-4" aria-hidden="true" data-id="element-241" data-mp="iy1hwfi08kiv" />
        </span>
        <div className="min-w-0" data-id="element-242" data-mp="npj94bu876qn">
          <p className="truncate text-sm font-semibold text-night-text" data-id="element-243" data-mp="nqkvvdkltho7">{node.label}</p>
          <p className="text-[11px] text-night-faint" data-id="element-244" data-mp="xkqfucwlypn5">
            Step {index + 1} · {kind.label}
          </p>
        </div>
      </div>
      <div className="mt-4 space-y-3" data-id="element-245" data-mp="sngkyhqg9lrx">
        {node.settings.map(setting => {
        const id = `setting-${node.id}-${setting.key.replace(/\W+/g, '-')}`;
        return <div key={setting.key} data-id="element-246" data-mp="inzcxtnq6vss">
              <label htmlFor={id} className="text-[11px] font-medium uppercase tracking-[0.06em] text-night-faint" data-id="element-247" data-mp="emxc58e5ubop">
                {setting.key}
              </label>
              <input id={id} value={setting.value} onChange={event => builder.updateSetting(node.id, setting.key, event.target.value)} className="mt-1 block w-full rounded-lg border border-night-line bg-night px-2.5 py-2 text-[12px] text-night-text focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet" data-id="element-248" data-mp="9um9vyvy6dsz" />
            </div>;
      })}
      </div>
      <div className="mt-4 flex flex-wrap gap-1.5" data-id="element-249" data-mp="22l7wih2j2miq">
        <button type="button" className={btn} disabled={index <= 0} onClick={() => builder.moveNode(node.id, -1)} data-id="element-250" data-mp="22ketnr6owh5v">
          <ArrowUpIcon className="h-3 w-3" aria-hidden="true" data-id="element-251" data-mp="26o4kyoer1cul" /> Move up
        </button>
        <button type="button" className={btn} disabled={index >= builder.nodes.length - 1} onClick={() => builder.moveNode(node.id, 1)} data-id="element-252" data-mp="2bja1f7pdtzba">
          <ArrowDownIcon className="h-3 w-3" aria-hidden="true" data-id="element-253" data-mp="1ix7h7yx3xluf" /> Move down
        </button>
        <button type="button" className={cn(btn, 'hover:text-[#F7A8A8]')} onClick={() => builder.removeNode(node.id)} data-id="element-254" data-mp="1nvip443udma0">
          <Trash2Icon className="h-3 w-3" aria-hidden="true" data-id="element-255" data-mp="1suliusedg62o" /> Remove
        </button>
      </div>
      <button type="button" onClick={() => builder.selectNode(null)} className="mt-3 text-[11px] font-semibold text-violet-ink hover:underline" data-id="element-256" data-mp="1xlv83rw0d7e1">
        Back to all steps
      </button>
    </div>;
}